ProfileMatchingComponentDetailsModalController.$inject = ["$scope", "modalData", "$filter", "$state"];

function ProfileMatchingComponentDetailsModalController($scope, modalData, $filter, $state) {
    const self = this;

    const LANGUAGES = {
        'aa': $filter('translate')('Afar'),
        'ab': $filter('translate')('Abkhazian'),
        'ae': $filter('translate')('Avestan'),
        'af': $filter('translate')('Afrikaans'),
        'ak': $filter('translate')('Akan'),
        'am': $filter('translate')('Amharic'),
        'an': $filter('translate')('Aragonese'),
        'ar': $filter('translate')('Arabic'),
        'he': $filter('translate')('Hebrew'),
        'as': $filter('translate')('Assamese'),
        'av': $filter('translate')('Avaric'),
        'ay': $filter('translate')('Aymara'),
        'az': $filter('translate')('Azerbaijani'),
        'ba': $filter('translate')('Bashkir'),
        'be': $filter('translate')('Belarusian'),
        'bg': $filter('translate')('Bulgarian'),
        'bho': $filter('translate')('Bhojpuri'),
        'bi': $filter('translate')('Bislama'),
        'bm': $filter('translate')('Bambara'),
        'bn': $filter('translate')('Bangla'),
        'bo': $filter('translate')('Tibetan'),
        'br': $filter('translate')('Breton'),
        'bs': $filter('translate')('Bosnian'),
        'ca': $filter('translate')('Catalan'),
        'ce': $filter('translate')('Chechen'),
        'ceb': $filter('translate')('Cebuano'),
        'ch': $filter('translate')('Chamorro'),
        'ckb': $filter('translate')('Central Kurdish'),
        'co': $filter('translate')('Corsican'),
        'cr': $filter('translate')('Cree'),
        'cs': $filter('translate')('Czech'),
        'cu': $filter('translate')('Church Slavic'),
        'cv': $filter('translate')('Chuvash'),
        'cy': $filter('translate')('Welsh'),
        'da': $filter('translate')('Danish'),
        'de': $filter('translate')('German'),
        'doi': $filter('translate')('Dogri'),
        'dv': $filter('translate')('Divehi'),
        'dz': $filter('translate')('Dzongkha'),
        'ee': $filter('translate')('Ewe'),
        'el': $filter('translate')('Greek'),
        'en': $filter('translate')('English'),
        'eo': $filter('translate')('Esperanto'),
        'es': $filter('translate')('Spanish'),
        'et': $filter('translate')('Estonian'),
        'eu': $filter('translate')('Basque'),
        'fa': $filter('translate')('Persian'),
        'ff': $filter('translate')('Fula'),
        'fi': $filter('translate')('Finnish'),
        'fj': $filter('translate')('Fijian'),
        'fo': $filter('translate')('Faroese'),
        'fr': $filter('translate')('French'),
        'fy': $filter('translate')('Western Frisian'),
        'ga': $filter('translate')('Irish'),
        'gd': $filter('translate')('Scottish Gaelic'),
        'gl': $filter('translate')('Galician'),
        'gn': $filter('translate')('Guarani'),
        'gom': $filter('translate')('Goan Konkani'),
        'gu': $filter('translate')('Gujarati'),
        'gv': $filter('translate')('Manx'),
        'ha': $filter('translate')('Hausa'),
        'haw': $filter('translate')('Hawaiian'),
        'hi': $filter('translate')('Hindi'),
        'hmn': $filter('translate')('Hmong'),
        'ho': $filter('translate')('Hiri Motu'),
        'hr': $filter('translate')('Croatian'),
        'ht': $filter('translate')('Haitian Creole'),
        'hu': $filter('translate')('Hungarian'),
        'hy': $filter('translate')('Armenian'),
        'hz': $filter('translate')('Herero'),
        'ia': $filter('translate')('Interlingua'),
        'id': $filter('translate')('Indonesian'),
        'ie': $filter('translate')('Interlingue'),
        'ig': $filter('translate')('Igbo'),
        'ii': $filter('translate')('Sichuan Yi'),
        'ik': $filter('translate')('Inupiaq'),
        'ilo': $filter('translate')('Iloko'),
        'io': $filter('translate')('Ido'),
        'is': $filter('translate')('Icelandic'),
        'it': $filter('translate')('Italian'),
        'iu': $filter('translate')('Inuktitut'),
        'iw': $filter('translate')('Hebrew'),
        'ja': $filter('translate')('Japanese'),
        'jw': $filter('translate')('Javanese'),
        'ka': $filter('translate')('Georgian'),
        'kg': $filter('translate')('Kongo'),
        'ki': $filter('translate')('Kikuyu'),
        'kj': $filter('translate')('Kuanyama'),
        'kk': $filter('translate')('Kazakh'),
        'kl': $filter('translate')('Kalaallisut'),
        'km': $filter('translate')('Khmer'),
        'kn': $filter('translate')('Kannada'),
        'ko': $filter('translate')('Korean'),
        'kr': $filter('translate')('Kanuri'),
        'kri': $filter('translate')('Krio'),
        'ks': $filter('translate')('Kashmiri'),
        'ku': $filter('translate')('Kurdish'),
        'kv': $filter('translate')('Komi'),
        'kw': $filter('translate')('Cornish'),
        'ky': $filter('translate')('Kyrgyz'),
        'la': $filter('translate')('Latin'),
        'lb': $filter('translate')('Luxembourgish'),
        'lg': $filter('translate')('Ganda'),
        'li': $filter('translate')('Limburgish'),
        'ln': $filter('translate')('Lingala'),
        'lo': $filter('translate')('Lao'),
        'lt': $filter('translate')('Lithuanian'),
        'lu': $filter('translate')('Luba-Katanga'),
        'lus': $filter('translate')('Mizo'),
        'lv': $filter('translate')('Latvian'),
        'mai': $filter('translate')('Maithili'),
        'mg': $filter('translate')('Malagasy'),
        'mh': $filter('translate')('Marshallese'),
        'mi': $filter('translate')('Māori'),
        'mk': $filter('translate')('Macedonian'),
        'ml': $filter('translate')('Malayalam'),
        'mn': $filter('translate')('Mongolian'),
        'mni-Mtei': $filter('translate')('Manipuri (Meitei Mayek)'),
        'mr': $filter('translate')('Marathi'),
        'ms': $filter('translate')('Malay'),
        'mt': $filter('translate')('Maltese'),
        'my': $filter('translate')('Burmese'),
        'na': $filter('translate')('Nauru'),
        'nb': $filter('translate')('Norwegian Bokmål'),
        'nd': $filter('translate')('North Ndebele'),
        'ne': $filter('translate')('Nepali'),
        'ng': $filter('translate')('Ndonga'),
        'nl': $filter('translate')('Dutch'),
        'nn': $filter('translate')('Norwegian Nynorsk'),
        'no': $filter('translate')('Norwegian'),
        'nr': $filter('translate')('South Ndebele'),
        'nso': $filter('translate')('Northern Sotho'),
        'nv': $filter('translate')('Navajo'),
        'ny': $filter('translate')('Nyanja'),
        'oc': $filter('translate')('Occitan'),
        'oj': $filter('translate')('Ojibwa'),
        'om': $filter('translate')('Oromo'),
        'or': $filter('translate')('Odia'),
        'os': $filter('translate')('Ossetic'),
        'pa': $filter('translate')('Punjabi'),
        'pi': $filter('translate')('Pali'),
        'pl': $filter('translate')('Polish'),
        'ps': $filter('translate')('Pashto'),
        'pt': $filter('translate')('Portuguese'),
        'qu': $filter('translate')('Quechua'),
        'rm': $filter('translate')('Romansh'),
        'rn': $filter('translate')('Rundi'),
        'ro': $filter('translate')('Romanian'),
        'ru': $filter('translate')('Russian'),
        'rw': $filter('translate')('Kinyarwanda'),
        'sa': $filter('translate')('Sanskrit'),
        'sc': $filter('translate')('Sardinian'),
        'sd': $filter('translate')('Sindhi'),
        'se': $filter('translate')('Northern Sami'),
        'sg': $filter('translate')('Sango'),
        'si': $filter('translate')('Sinhala'),
        'sk': $filter('translate')('Slovak'),
        'sl': $filter('translate')('Slovenian'),
        'sm': $filter('translate')('Samoan'),
        'sn': $filter('translate')('Shona'),
        'so': $filter('translate')('Somali'),
        'sq': $filter('translate')('Albanian'),
        'sr': $filter('translate')('Serbian'),
        'ss': $filter('translate')('Swati'),
        'st': $filter('translate')('Southern Sotho'),
        'su': $filter('translate')('Sundanese'),
        'sv': $filter('translate')('Swedish'),
        'sw': $filter('translate')('Swahili'),
        'ta': $filter('translate')('Tamil'),
        'te': $filter('translate')('Telugu'),
        'tg': $filter('translate')('Tajik'),
        'th': $filter('translate')('Thai'),
        'ti': $filter('translate')('Tigrinya'),
        'tk': $filter('translate')('Turkmen'),
        'tl': $filter('translate')('Tagalog'),
        'tn': $filter('translate')('Tswana'),
        'to': $filter('translate')('Tongan'),
        'tr': $filter('translate')('Turkish'),
        'ts': $filter('translate')('Tsonga'),
        'tt': $filter('translate')('Tatar'),
        'tw': $filter('translate')('Twi'),
        'ty': $filter('translate')('Tahitian'),
        'ug': $filter('translate')('Uyghur'),
        'uk': $filter('translate')('Ukrainian'),
        'ur': $filter('translate')('Urdu'),
        'uz': $filter('translate')('Uzbek'),
        've': $filter('translate')('Venda'),
        'vi': $filter('translate')('Vietnamese'),
        'vo': $filter('translate')('Volapük'),
        'wa': $filter('translate')('Walloon'),
        'xh': $filter('translate')('Xhosa'),
        'yi': $filter('translate')('Yiddish'),
        'yo': $filter('translate')('Yoruba'),
        'za': $filter('translate')('Zhuang'),
        'zh': $filter('translate')('Chinese'),
        'zu': $filter('translate')('Zulu')
    };

    const init = async () => {
        self.modalData = modalData;
        const languageCode = modalData.cvLanguage;
        self.cvLanguageCode = modalData.cvLanguage;
        self.jobLanguageCode = modalData.jobLanguage;

        if (LANGUAGES[languageCode]) {
            self.resumeLanguage = LANGUAGES[languageCode];
        }

        self.modalData.topCandidates = modalData.topCandidates.filter(candidate => candidate.applicantId !== modalData.applicationId);
    };

    self.redirectCandidateSpeedy = (candidate) => {
        return  $state.href("appLayout.harriSH.AMS.applicants", {
            job_id: self.modalData.jobId,
            bucket_id: 'DIRECT',
            app_id: candidate.applicantId
        });
    };

    self.close = () => {
        $scope.$hide();
    };

    init();
}

export const getProfileMatchingComponentDetailsModalController = (modalData) => {
    return {
        controller: ProfileMatchingComponentDetailsModalController,
        controllerAs: '$ctrl',
        templateUrl: '../modules/speedy_screen/components/profile-matching-modals/profile-matching-component-details-modal/profile_matching_component_details.modal.html',
        show: true,
        backdrop: false,
        resolve: {
            modalData: modalData,
        }
    };
};